import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div className="pt-20 md:pt-24" data-testid="about-page">
      <section className="px-6 md:px-12 py-24 md:py-40">
        <div className="max-w-5xl">
          <div className="label-eyebrow mb-6">The Atelier</div>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="font-display text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.92]"
          >
            We started because every cap we owned was{" "}
            <span className="italic font-light text-[#C9A961]">almost right.</span>
          </motion.h1>
          <p className="mt-12 max-w-2xl text-lg text-black/70 leading-relaxed">
            The Crown &amp; Stitch began in a single room with two
            spools of mercerised cotton, and a list of every detail we'd ever wished a
            cap got correct. We obsess over the things that take seconds longer — the
            curl of the brim, the way thread catches afternoon light, the weight of the
            sweatband against your hairline.
          </p>
        </div>
      </section>

      <section className="grid md:grid-cols-2 border-y border-[#E5E3DE]">
        <div className="bg-[#F7F5F0] p-8 md:p-16 lg:p-24 flex flex-col justify-center min-h-[60vh]">
          <div className="label-eyebrow mb-6">Materials</div>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight mb-8">
            What we use, and why.
          </h2>
          <ul className="space-y-6 max-w-md">
            {[
              ["100% mercerised cotton twill", "Holds its shape, breathes, ages well."],
              ["Genuine brass eyelets", "Plastic dents. Brass earns a patina."],
              ["Hand-walked embroidery", "Every stitch checked before leaving the bench."],
              ["Numbered cotton tag", "So each piece is traceable to its bench."],
            ].map(([t, d]) => (
              <li key={t} className="border-l-2 border-black pl-4">
                <div className="font-display text-lg">{t}</div>
                <div className="text-sm text-black/60 mt-1">{d}</div>
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-[#0A0A0A] text-white p-8 md:p-16 lg:p-24 flex flex-col justify-center">
          <div className="label-eyebrow text-white/50 mb-6">For brands</div>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight mb-8">
            Want one made for your team?
          </h2>
          <p className="text-white/70 max-w-md leading-relaxed">
            We work with founders, marketing teams, and event organisers on numbered
            runs of branded caps. Most quotes return within 24 hours.
          </p>
          <Link
            to="/custom"
            className="mt-10 inline-flex w-fit bg-white text-black px-7 py-4 text-sm tracking-wide hover:bg-[#C9A961] hover:text-white transition-colors"
          >
            Start a brief →
          </Link>
        </div>
      </section>
    </div>
  );
}
